import React from "react";

function TermsofService() {
  return <div>TermsofService</div>;
}

export default TermsofService;
